import Vue from 'vue'
import {VueReCaptcha} from "vue-recaptcha-v3"
Vue.use(VueReCaptcha, {siteKey: "6Lf8jM8ZAAAAAMcZjTKgIQ6AvFl04rHbix6MLYKq"})